import { Outlet } from 'react-router-dom'

import { BenefitsSettingsPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import PageLoading from 'modules/layout/components/Page/Loading'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(BenefitsSettingsPageDocument, {
    variables: { companyId: company.id },
  })

  const canSeeBenefits = data?.benefits?._policies?.sidebarSeeBenefitsTopLevelItem?.can

  if (loading) {
    return <PageLoading />
  }

  return (
    <AuthorizeUser authorizeFn={() => canSeeBenefits ?? false}>
      <Outlet />
    </AuthorizeUser>
  )
}

export default RootPage
